import { createSelector, Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { SitesManagementState } from '../types'

const getFeatureState: Selector<ReduxState, SitesManagementState> = (state) => state.sitesManagement

export const featureStateSelector = createSelector(getFeatureState, (state) => state)

export default featureStateSelector
